<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import {
  getColorById as fetchData,
  createColor as createData,
  updateColor as updateData,
} from "@/api/colors";
import defaultScheme from "@/api/schemes/colors";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        createData,
        updateData,
        updateScheme,
      },
    };
  },
};
</script>
